// extracted by mini-css-extract-plugin
module.exports = {"iconTile":"IconTitle_iconTile__8pi1K","icon":"IconTitle_icon__ev4f2","htmlBody":"IconTitle_htmlBody__uiKAV","buttonWrapper":"IconTitle_buttonWrapper__6YQSy"};